import { getStandaloneComponentRenderer, Footer } from "@kaltura/mediaspace-shared-layout";

export const Component = Footer;

export const render = getStandaloneComponentRenderer(Footer, true);
